import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import CheckcircleIcon from 'icons/Checkcircle.icon';

import './DocumentStatusBadge.styles.scss';

type DocumentStatusBadgeProps = {
  className?: string;
  numberOfCheckedFiles: number;
};

const DocumentStatusBadge: React.FC<DocumentStatusBadgeProps> = (props) => {
  const { className, numberOfCheckedFiles } = props;

  const classes = classNames('document-status-badge', className);

  const { t } = useTranslation();

  if (!numberOfCheckedFiles) return null;

  return (
    <p className={classes}>
      <CheckcircleIcon />
      {t('numberOfFiles', { count: numberOfCheckedFiles })}
    </p>
  );
};

export default DocumentStatusBadge;
